module.exports = __webpack_public_path__ + "static/media/fulllength.4af51ac8.png";